import React, { useState } from "react";
import { Modal, ModalFooter, Button } from "reactstrap";
import { ArrowLeft } from "react-feather";

import { MarketingActivity as Activity, MarketingObjective as Objective } from "../../../api";

import ActivityModalContent from "./ActivityModalContent";
import ObjectiveModalContent from "./ObjectiveModalContent";

export type ModalItemType = "activity" | "objective";

interface DetailsModalProps {
  isOpen: boolean,
  itemId?: string;
  itemType?: ModalItemType;
  activitiesById: Record<string, Activity | undefined>;
  objectivesById: Record<string, Objective | undefined>;
  handleSelectActivity: (activityId: string) => any;
  handleSelectObjective: (objectiveId: string) => any;
  handleClose: () => any,
}

interface HistoryItem {
  id: string;
  type: ModalItemType;
}

const maxNavDepth = 1;

const DetailsModal: React.FC<DetailsModalProps> = ({
  isOpen,
  itemId,
  itemType,
  activitiesById,
  objectivesById,
  handleSelectActivity,
  handleSelectObjective,
  handleClose,
}) => {

  const [history, setHistory] = useState<HistoryItem[]>([]);

  const activity = itemId ? activitiesById[itemId] : void 0;

  const objective = itemId ? objectivesById[itemId] : void 0;

  const showBackButton = history.length !== 0;

  const showLinks = history.length < maxNavDepth;

  const appendToHistory = (id: string, type: ModalItemType) => {
    setHistory(history.slice().concat([{ id, type }]));
  };

  const removeFromHistory = () => {
    const arr = history.slice(0, -1);
    setHistory(arr);
  };

  const goToActivity = (id: string) => {
    if (itemId) {
      handleSelectActivity(id);
      appendToHistory(itemId, "objective");
    }
  };

  const goToObjective = (id: string) => {
    if (itemId) {
      handleSelectObjective(id);
      appendToHistory(itemId, "activity");
    }
  };

  const goBack = () => {
    const item = history.slice().pop();
    switch (item?.type) {
      case "activity":
        handleSelectActivity(item.id);
        break;
      case "objective":
        handleSelectObjective(item.id);
        break;
    }
    removeFromHistory();
  };

  return (
    <div>
      <Modal
        isOpen={isOpen}
        aria-labelledby="contained-modal-title-vcenter"
        centered>

        {itemType === "activity"
          ? (!!activity
            ? (
              <ActivityModalContent
                activity={activity}
                objectivesById={objectivesById}
                showLinks={showLinks}
                handleSelectObjective={goToObjective} />)
            : "Activity not found")
          : itemType === "objective"
            ? (!!objective
              ? (
                <ObjectiveModalContent
                  objective={objective}
                  activitiesById={activitiesById}
                  showLinks={showLinks}
                  handleSelectActivity={goToActivity} />)
              : "Objective not found")
            : null}

        <ModalFooter>
          {showBackButton &&
            <Button size="sm" color="neutral" onClick={() => goBack()}>
              <span className="d-flex align-items-center"></span>
              <ArrowLeft size={15} />
              <span className="ml-1">Back</span>
            </Button>
          }
          <div className="flex-grow-1 d-flex justify-content-end">
            <Button size="sm" color="primary" onClick={handleClose}>Close</Button>
          </div>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default DetailsModal;
